import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { authGuard } from 'src/app/auth/auth-guard.service';
import { MarketingTextMessageComponent } from 'src/app/component-modules/recruiting-components/marketing-text-message/marketing-text-message.component';
import { RenewalReportComponent } from './renewal-report/renewal-report.component';


const routes: Routes = [

  {
    path: "text-message",
    component: MarketingTextMessageComponent,
    canActivate: [
      authGuard(["marketing"])
    ],
    title: "Marketing SMS | Mission Control"
  },
  {
    path: "renewal-report",
    component: RenewalReportComponent,
    canActivate: [
      authGuard()
    ],
    title: "Renewal Report | Mission Control"
  }

]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class RecruitingRoutingModule { }
